import { render } from "./PdfContentDetail.vue?vue&type=template&id=384fd706"
import script from "./PdfContentDetail.vue?vue&type=script&lang=js"
export * from "./PdfContentDetail.vue?vue&type=script&lang=js"

import "./PdfContentDetail.vue?vue&type=style&index=0&id=384fd706&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__